import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { RecordingSessionService } from '../recording/recording-session.service';

export interface NavLink {
  name: string;
  route: string;
  active: boolean;
  /** When set, link shows an icon instead of text (saves horizontal space on small screens). */
  icon?: 'home';
}

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: '../navigation/navigation.component.html',
  styleUrls: ['../navigation/navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  navLinks: NavLink[] = [
    { name: 'Dashboard', route: '/v0/dashboard', active: false, icon: 'home' },
    { name: 'Transcriptions', route: '/v0/transcriptions', active: false },
    { name: 'Patients', route: '/v0/patients', active: false },
    { name: 'Settings', route: '/v0/settings', active: false }
  ];

  isLoggedIn = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    private recordingSession: RecordingSessionService
  ) {}

  ngOnInit() {
    // Check if user is logged in
    this.checkLoginStatus();
    
    // Listen for route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateActiveLink();
      this.checkLoginStatus();
    });
    
    // Set initial active link
    this.updateActiveLink();
  }

  checkLoginStatus(): void {
    // Check if JWT token exists in localStorage
    this.isLoggedIn = !!localStorage.getItem('jwt_token');
  }

  onNewRecording(): void {
    if (this.recordingSession.isCaptureActive()) {
      this.recordingSession.requestNewRecordingFromNav();
      return;
    }
    void this.router.navigate(['/v0/recording']);
  }

  onLogout(): void {
    // Clear the JWT token from localStorage
    localStorage.removeItem('jwt_token');
    
    // Call backend logout endpoint to clear server-side session
    this.http.post('/logout', {}, { withCredentials: true }).subscribe({
      next: () => {
        this.router.navigate(['/logout']);
      },
      error: () => {
        // Still navigate to logout page even if logout request fails
        this.router.navigate(['/logout']);
      }
    });
  }

  setActiveLink(linkName: string) {
    this.navLinks.forEach(link => {
      link.active = link.name === linkName;
    });
  }

  updateActiveLink() {
    const currentRoute = this.router.url.split('?')[0];
    this.navLinks.forEach(link => {
      link.active =
        currentRoute === link.route ||
        (currentRoute === '/v0' && link.route === '/v0/dashboard') ||
        (currentRoute === '/v0/' && link.route === '/v0/dashboard');
    });
  }
} 